// // component To export json data
import axios from "axios";
// const fs = require("fs");

const backend_addresses = {
  new_topic_add:
    "https://docs-io-api.netlify.app/.netlify/functions/server/docs/newtopic",
  notebook_topic:
    "https://docs-io-api.netlify.app/.netlify/functions/server/docs/topics",
  notebook_topic_guest:
    "https://docs-io-api.netlify.app/.netlify/functions/server/guest/topics",
  update_topic:
    "https://docs-io-api.netlify.app/.netlify/functions/server/docs/update",
  topic_list:
    "https://docs-io-api.netlify.app/.netlify/functions/server/docs/topicList",
  topic_list_guest:
    "https://docs-io-api.netlify.app/.netlify/functions/server/guest/topicList",
  delete_topic:
    "https://docs-io-api.netlify.app/.netlify/functions/server/docs/del",
  login: "https://docs-io-api.netlify.app/.netlify/functions/server/login",
  search_query: "https://docs-io-api.netlify.app/.netlify/functions/server/search/query",
};
// const backend_addresses = {
//   new_topic_add:
//     "http://localhost:4000/.netlify/functions/server/docs/newtopic",
//   notebook_topic: "http://localhost:4000/.netlify/functions/server/docs/topics",
//   notebook_topic_guest:
//     "http://localhost:4000/.netlify/functions/server/guest/topics",
//   update_topic: "http://localhost:4000/.netlify/functions/server/docs/update",
//   topic_list: "http://localhost:4000/.netlify/functions/server/docs/topicList",
//   topic_list_guest:
//     "http://localhost:4000/.netlify/functions/server/guest/topicList",
//   delete_topic: "http://localhost:4000/.netlify/functions/server/docs/del",
//   login: "http://localhost:4000/.netlify/functions/server/login",
//   search_query: "http://localhost:4000/.netlify/functions/server/search/query",
// };

const insertTopic = async (topic_name, token, user) => {
  console.log("here for process.:", topic_name);
  var data = { new_topic: topic_name, user: user };
  const res = await axios
    .post(backend_addresses.new_topic_add, data, {
      headers: {
        "auth-token": token,
      },
    })
    .then((res) => {
      // console.log('new topic sent',res);
      return res;
    })
    .catch((err) => {
      console.error(err);
    });
  // console.log("from data js ",res);
  return res;
};

const Login = async (data) => {
  const res = await axios.post(
    backend_addresses.login,
    // 'https://docs-io-api.netlify.app/.netlify/functions/server/login',
    // "http://localhost:4000/.netlify/functions/server/login",
    { google_id: data[0], name: data[1], email: data[2], img_url: data[3] }
  );
  // .then((res) => {
  //   console.log('Login',res.data);
  //   // return res.data;
  // })
  // .catch(err => {
  //   console.error(err);
  // });
  // const res1 = await res.json();
  console.log(" Data >> Login >> ", res.data.login);
  return res;
  // console.log("cell to be added","t i ",topic,"c i " , cell_index,"source ", source);
};

const Notebook_data = async (user, topic, token) => {
  console.log("Data.js >> NoteBook_Data >> ", user);
  let data;
  if (user == "Guest") {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fileName: topic }),
    };

    const response = await fetch(
      backend_addresses.notebook_topic_guest,
      requestOptions
    );
    // console.log("1022", response );
    data = await response.json();
  } else {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "auth-token": token },
      body: JSON.stringify({ fileName: topic }),
    };

    const response = await fetch(
      backend_addresses.notebook_topic,
      requestOptions
    );
    // console.log("1022", response );
    data = await response.json();
  }
  console.log(" Data >> Notebook_data", data);
  // this.setState({ postId: data.id });
  //
  return data;
};

const updateCell = async (topic, token) => {
  await axios
    .post(
      backend_addresses.update_topic,
      { updated_info: topic },
      {
        headers: {
          "auth-token": token,
        },
      }
    )
    .then(() => console.log("topic sent"))
    .catch((err) => {
      console.error(err);
    });
};

const deleteTopic = async (topic_info, token, user) => {
  await axios
    .post(
      backend_addresses.delete_topic,
      { topic_info: topic_info, user: user },
      {
        headers: {
          "auth-token": token,
        },
      }
    )
    .then(() => console.log("topic sent for Deletion"))
    .catch((err) => {
      console.error(err);
    });
};

const topicList = async (user, token) => {
  console.log("Data.js >> TopicList_Data >> ", user);
  let res;
  if (user == "Guest") {
    res = await axios.post(
      backend_addresses.topic_list_guest,
      { user: user },
      {
        headers: {
          "auth-token": token,
        },
      }
    );
  } else {
    res = await axios.post(
      backend_addresses.topic_list,
      { user: user },
      {
        headers: {
          "auth-token": token,
        },
      }
    );
  }
  // .then(() => console.log('topic sent for Deletion'))
  // .catch(err => {
  //   console.error(err);
  // });
  console.log(" Data >> TopicList >>", res.data);
  return res.data;
};

const insertCell = async (topic, cell_index, cell_type, token) => {
  const content = {
    cell_layout: { cell_type: cell_type, code_lan: "", img_format: "" },
    source: "Add Edit Content Here....!",
  };
  topic.cells.splice(cell_index + 1, 0, content);
  await axios
    .post(
      backend_addresses.update_topic,
      { updated_info: topic },
      {
        headers: {
          "auth-token": token,
        },
      }
    )
    .then(() => console.log("topic sent"))
    .catch((err) => {
      console.error(err);
    });
  // console.log("cell to be added","t i ",topic,"c i " , cell_index,"source ", source);
};
const searchQuery = async (user, query, token) => {
  let res = await axios.post(
    backend_addresses.search_query,
    { user: user, query: query },
    {
      headers: {
        "auth-token": token,
      },
    }
  );
  console.log("search q => ", res.data);
  return res.data;
};

export {
  Notebook_data,
  deleteTopic,
  Login,
  insertCell,
  updateCell,
  insertTopic,
  topicList,
  searchQuery,
};
